<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>


    <div class="page lead-page mt-4" v-else-if="loaded" >
        
        <b-input-group class="mb-4" >
            <b-form-input v-model="filter" placeholder="Type to search" class="search-input atlass-input-borderless" />
            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
        </b-input-group>
        
        <div class="col-12 d-none" v-for="(tag, index) in matches"  >
            <div class="row pt-2 pb-2 tag-row" >
                <span class="span-width" > {{ formatDate(tag) }} </span>
                <span class="tag-span" >
                    ${{tag.price}}  {{tag.name}} ( {{tag.tag}} )
                    <a @click="preventDeleteOrder( tag )" v-if="pageType == 'edit'" > <font-awesome-icon icon="trash-alt" /> </a>
                </span>
            </div>
        </div>
        
        <vue-good-table
            class=""
            :columns="columnns"
            :rows="data"
            styleClass="vgt-table atlass-datatable mt-4 firstTdBold font-size-14"
            :search-options="{ enabled: true, externalQuery: filter }"
            :pagination-options="{ 
                enabled: true,
                perPage: 20,
                perPageDropdown: [50, 100],
                ropdownAllowAll: true,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Leads per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            }"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
            
             >
            
            <template slot="table-row" slot-scope="props">
                
                <span v-if="props.column.field == 'status'">
                    
                                        
                    <b-dropdown size="sm" variant="transparent" toggle-class="text-decoration-none font-size-14 not-active p-0 m-0 line-height-1 border-none" no-caret right split-variant class="border-none">
                        <template #button-content>
                            <b-badge v-if="props.row.status == 'completed'" variant="success"> completed <font-awesome-icon icon="chevron-down" /> </b-badge>
                            <b-badge v-else-if="props.row.status == 'refunded'"  variant="danger"> refunded <font-awesome-icon icon="chevron-down" /> </b-badge>
                            <b-badge v-else-if="props.row.status == 'failed'"  variant="danger"> failed <font-awesome-icon icon="chevron-down" /> </b-badge>
                            <b-badge v-else-if="props.row.status != ''"  variant="secondary"> {{props.row.status}} <font-awesome-icon icon="chevron-down" /> </b-badge>
                            
                        </template>
                        <b-dropdown-item-button class="cursor-pointer" v-if="props.row.status != 'completed'" @click="updateOrderStatus(props.row, 'completed')" > Mark as completed </b-dropdown-item-button>
                        <b-dropdown-item-button class="cursor-pointer" v-if="props.row.status != 'refunded'" @click="updateOrderStatus(props.row, 'refunded')" > Mark as refunded </b-dropdown-item-button>
                    </b-dropdown>
                </span>
                
                <span v-else-if="props.column.field == 'tag'">
                        
                    {{props.row.tag}}  

                    <font-awesome-icon :icon="['fa', 'shopping-cart']" class="graymedium-color" :id="`tooltip--${props.row.id}`" v-if="props.row.orderItems" />
                    <b-tooltip :target="`tooltip--${props.row.id}`" placement="right" triggers="hover"  >
                        <span v-for="item in props.row.orderItems" :key="item.tag" >
                            <span> {{item.Name}} ( {{item.tag}} )  </span> <br>
                        </span>
                    </b-tooltip>

                </span>
                
                <span v-else-if="props.column.field == 'firstTouch'">
                    <img v-if="props.row.firstTouch.origin == 'FACEBOOK'" src="@/assets/icons/facebook.png" :id="`tooltip--firstTouch-${props.row.id}`" style="height:15px;width:15px;" /> 
                    <img v-else-if="props.row.firstTouch.origin == 'GOOGLE'" src="@/assets/icons/googleadwords.png" :id="`tooltip--firstTouch-${props.row.id}`" style="height:15px;width:15px;"  /> 
                    <!--
                    <b-tooltip :target="`tooltip--firstTouch-${props.row.id}`" placement="right" triggers="hover" >                                    
                         {{ props.row.firstTouch }}  
                    </b-tooltip>
                    -->
                    <span v-if="props.row.firstTouch.tag  " :id="`tooltip--${props.column.field}--${props.row.id}`" > {{ renderTag( props.row.firstTouch ) }} </span>
                    <b-tooltip :target="`tooltip--${props.column.field}--${props.row.id}`" placement="bottom" triggers="hover"  >
                        {{ props.row.firstTouch.tag }}
                    </b-tooltip>

                </span>

                <span v-else-if="props.column.field == 'lastTouch'">
                    <img v-if="props.row.touchpoints.length > 0 && props.row.touchpoints[ props.row.touchpoints.length - 1 ].origin == 'FACEBOOK'" src="@/assets/icons/facebook.png" :id="`tooltip--lastTouch-${props.row.id}`" style="height:15px;width:15px;" /> 
                    <img v-else-if="props.row.touchpoints.length > 0 && props.row.touchpoints[ props.row.touchpoints.length - 1 ].origin == 'GOOGLE'" src="@/assets/icons/googleadwords.png" :id="`tooltip--lastTouch-${props.row.id}`" style="height:15px;width:15px;"  /> 
                    
                    <span v-if="props.row.touchpoints.length > 0 " :id="`tooltip--${props.column.field}--${props.row.id}`" > {{ renderTag( props.row.touchpoints[ props.row.touchpoints.length - 1 ] ) }} </span>
                    <b-tooltip :target="`tooltip--${props.column.field}--${props.row.id}`" placement="bottom" triggers="hover" v-if="props.row.touchpoints.length > 0 " >
                        {{ props.row.touchpoints[ props.row.touchpoints.length - 1 ].tag }}
                    </b-tooltip>
                    
                    <font-awesome-icon :icon="['fas', 'tags']" class="graymedium-color" :id="`order-tooltip--touchpoints--${props.row.id}`" v-if="props.row.touchpoints.length > 0" />
                    <b-tooltip :target="`order-tooltip--touchpoints--${props.row.id}`" placement="right" triggers="hover"  >
                        
                        <span class="d-block" v-for="(touchpoint, index) in props.row.touchpoints" >
                            
                            {{ formatDate(touchpoint) }} - 
                            <img v-if="touchpoint.origin == 'FACEBOOK'" src="@/assets/icons/facebook.png" style="height:15px;width:15px;" /> 
                            <img v-else-if="touchpoint.origin == 'GOOGLE'" src="@/assets/icons/googleadwords.png" style="height:15px;width:15px;"  /> 
                            {{ touchpoint.name }} 

                        </span>
                        
                    </b-tooltip>
                    
                </span>
                

                <span v-else-if="props.column.field == 'actions'">
                    
                    <b-dropdown size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="11" width="11" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14">
                        <b-dropdown-item-button class="d-none" @click="routeRow(props.row.id)" >Edit</b-dropdown-item-button>
                        <b-dropdown-item-button @click="preventDeleteOrder(props.row)" >Delete</b-dropdown-item-button>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item-button v-if="adminRole == 0" @click="reprocessIPEvents( props.row )" > Reprocess events </b-dropdown-item-button>
                    </b-dropdown>
                    
                    <a class="mr-3 d-none" @click="routeRow(props.row.id)"> <font-awesome-icon icon="edit" /> </a>
                    <a class="mr-2 d-none" @click="preventDeleteOrder(props.row)"> <font-awesome-icon icon="trash-alt" /> </a>
                </span>
                
                <span v-else  >
                  {{props.formattedRow[props.column.field]}}
                </span>
            </template>
            
        </vue-good-table>
        
    </div>
</template>

<script>

import firebase from "firebase";
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';
import axios from 'axios'

export default {
    name: 'tagsComponent',
    props: {
        data: { 
            type: [Array],
        },
        pageType: {
            type: [String],
            default: 'edit'
        }
    },
    data: function(){
        return {
            filter: '',
            loaded: false,
            timeout: 100,
            columnns:[
                {
                    label: 'NAME',
                    field: 'name',
                    //field: this.returnName,
                },
                {
                    label: 'TAG',
                    field: 'tag',
                    //field: this.returnTagColumn,
                    //field: this.returnName,
                },
                {
                    label: 'FIRST TOUCH',
                    field: 'firstTouch',
                    hidden: true,
                    //field: this.returnName,
                    //formatFn: this.renderTag,
                },
                {
                    //label: 'LAST TOUCH',
                    label: 'TOUCHPOINTS ( LAST )',
                    field: 'lastTouch',
                    //field:.returnName,
                    //formatFn: this.renderTag,
                },
                {
                    label: 'AVG TIME',
                    //field: '',
                    field: function(item){
                        //console.log(item)
                        let SUM = 0
                        item.touchpoints.forEach((touchpoint)=>{
                            let duration = item.datetime - touchpoint.datetime
                            SUM = SUM + parseInt( duration )
                        })
                        
                        return helper.secondsToDhms( ( SUM / item.touchpoints.length ).toFixed(0) )
                    },
                    //formatFn: this.renderTag,
                },
                {
                    label: 'PRICE',
                    field: 'price',
                    //field: this.returnName,
                    type: 'number',
                    
                },
                {
                    label: 'STATUS',
                    field: 'status',
                    //field: this.returnName,
                    //type: 'number',
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
                {
                    label: 'CREATED',
                    field: this.formatDate,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
                {
                    label: 'ACTION',
                    field: 'actions',
                    sortable: false,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
            ],
            adminRole: null
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        //console.log(this.data)
    },
    mounted: function () {
        this.loaded = true;
        this.adminRole = helper.getAdminLevel()
        
    },
    beforeDestroy() {
    },
    methods: {
        formatDate(a){
            //return this.$moment.unix(a.datetime).format( 'HH:mm:ss MMM D, YYYY' )
            return helper.formatDate( a.datetime, 'HH:mm:ss MMM D, YYYY' )
        },
        routeRow( id ){
            //open modal
        },
        renderTag(field){
            return field.tag
        },
        
        updateOrderStatus( order, status ){
            
            //init org ID
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            let leadID = order.leadID
            
            firebase.firestore().collection('organizations/'+orgID+'/orders').doc( order.id ).update( { status: status } )
            
            if( status == 'refunded' ){
                //DECREMENT REVENUE
                firebase.firestore().collection('organizations/'+orgID+'/leads').doc(leadID).update( { revenue: firebase.firestore.FieldValue.increment( -Math.abs(order.price) ) } );
            }else if( status == 'completed' ){
                //DECREMENT REVENUE
                firebase.firestore().collection('organizations/'+orgID+'/leads').doc(leadID).update( { revenue: firebase.firestore.FieldValue.increment( Math.abs(order.price) ) } );
            }
            
            this.$toast.success({
                title: 'Success',
                message: 'Order mared as '+status
            })
            
            order.status = status
            
        },
        
        preventDeleteOrder( item ){
            
            console.log(item)
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the conversion will be deleted as well',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    //this.deleteOrder(item);
                    
                    //delete from sql
                    this.delete_SQL_order( item.id )
                    
                }
            })
            
        },        
        deleteOrder: function(order){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            let leadID = order.leadID
            
            const db = firebase.firestore();
            
            let refOrder = db.collection('organizations/'+orgID+'/orders').doc( order.id ).delete()
            
            //delete from sql
            this.delete_SQL_order( order.id )
            
            if( order.status == 'complete' ){
                
                //DECREMENT REVENUE
                let decrement = firebase.firestore.FieldValue.increment( -Math.abs(order.price) )
                db.collection('organizations/'+orgID+'/leads').doc(leadID).update( { revenue: decrement } );

                db.collection('organizations/'+orgID+'/products').where( 'tag', '==', order.tag ).get()
                .then((result)=>{
                    result.forEach(doc =>{
                        let PRODUCT = doc.data()
                        let PRODUCT_ID = doc.id;
                        db.collection('organizations/'+orgID+'/products').doc( PRODUCT_ID ).update( { conversions: admin.firestore.FieldValue.increment( -1 ) } );
                    })
                })
                            
            }
                
            //DELETE TAGS  
            //let refTag = db.collection('organizations/'+orgID+'/leads/'+leadID+'/tags').doc(order.tagID).delete()
            /*
            db.collection('organizations/'+orgID+'/leads/'+leadID+'/tags').where('datetime', '==', order.datetime ).get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    doc.ref.delete();
                });
            });
            */
            
            db.collection('organizations/'+orgID+'/leads/'+leadID+'/tags').doc( order.tagID ).delete()
            
            console.log("Success")
            this.$toast.success({
                title: 'Success',
                message: 'Order deleted'
            })

            setTimeout(function(){ 
                //console.log(this.$parent)
                this.loaded = true
                //this.$parent.$parent.$parent.get_data( 'tags' );
                //remove from current array
                
                if ('panel' in this.$parent.$refs) {
                    console.log('order modal')
                    //RELOAD TAG LIST
                    this.$parent.$parent.$parent.get_data( 'orders' );
                    //UPDATE LEAD REVENUE
                    //console.log( this.$parent.$parent.$parent )
                    //this.$parent.$parent.$parent.$parent.get_data();
                    this.$parent.$parent.$parent.ID.revenue -= order.price;
                    
                }else{
                    console.log('order page')
                    //RELOAD TAG LIST
                    this.$parent.get_data();
                    //UPDATE LEAD REVENUE
                    this.$parent.$parent.data.revenue -= order.price;
                    
                }
                
            }.bind(this), this.timeout );
                
        },
        
        delete_SQL_order(orderID){
              
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": Cookies.get('user-token') }
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                url: process.env.ROOT_API+'/sql/orders/delete', 
                headers: headers, 
                data: { 
                    "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    //"APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    "orderID": orderID
                } 
            })
            .then(resp => {
                //console.log(resp)
                
                if( resp.data.status == 103 ){
                    
                    this.$swal({
                        title: 'Refresh required',
                        text: 'Please reload the page in order to refresh the session token ',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, refresh'
                    }).then((result) => {
                        if (result.value) { 
                            window.location.reload()
                        }
                    })
                    
                }else{
                    
                    this.$toast.success({
                        title: 'Success',
                        message: 'Order deleted'
                    })

                    setTimeout(function(){ 
                        //console.log(this.$parent)
                        this.loaded = true
                        //this.$parent.$parent.$parent.get_data( 'tags' );
                        //remove from current array

                        if ('panel' in this.$parent.$refs) {
                            console.log('order modal')
                            //RELOAD TAG LIST
                            this.$parent.$parent.$parent.get_data( 'orders' );
                            //UPDATE LEAD REVENUE
                            //console.log( this.$parent.$parent.$parent )
                            //this.$parent.$parent.$parent.$parent.get_data();
                            this.$parent.$parent.$parent.ID.revenue -= order.price;

                        }else{
                            console.log('order page')
                            //RELOAD TAG LIST
                            this.$parent.get_data();
                            //UPDATE LEAD REVENUE
                            this.$parent.$parent.data.revenue -= order.price;

                        }

                    }.bind(this), this.timeout );
                    
                }
                
            })
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error deleting order. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        reprocessIPEvents( order ){
            //console.log(order)
            
            this.$toast.success({
                title: 'Info',
                message: 'Processing. This could take a while',
                timeOut: 9000
            })
            
            let params = Cookies.get('user-token')
            
            //APPKEY, LEADID, IP_SALT, startdate
            let data = {
                APPKEY: order.APPKEY,
                leadID: order.leadID,
                IP_SALT: order.IP_SALT,
                orderDatetime: order.datetime,
                orderID: order.id,
            }
            
            if( !order.IP_SALT ){
                data.IP_SALT = order.lead.IP_SALT
            } 
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/app/reprocess-ip-events', headers: headers, data: data })
                .then(resp => {
                
                console.log(resp)
                
                if( resp.status == 200 ){
                    let r = resp.data;
                    if( r.status == 100 ){
                        
                        this.$toast.success({
                            title: 'Success',
                            message: 'Order reprocessed. Please make sure to refresh the page to see updated data.'
                        })
                            
                    }else{
                        
                        this.$toast.warn({
                            title: 'Warning',
                            message: r.data
                        })
                        
                    }
                }
                    
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
        }
    },
    computed: {
        matches() {
            return this.filter
                ? this.data.filter(row => {
                  let match = false
                  for (let key in row) {
                    //console.log(campaign['name']);
                    if (row['name'].toLowerCase().includes(this.filter.toLowerCase())) {
                      return true
                    }
                  }
                })
                : this.data
        }
    },
    watch: {
        ID: function(){
            if( typeof this.ID == 'string' ){
                this.docID = this.ID
            }else{
                this.data = this.ID
            }
    
            //this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >


    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 150px;
        display: inline-block;
        margin-right: 10px;
    }
    .tag-span{
        display: inline-block;
    }
    .tag-span a{
        display: none;
        transition: all .3s;
        transition-timing-function: ease-out;
    }
    
    .tag-row:hover a{
        display: inline-block;
        transition: all .3s;
        transition-timing-function: ease-out;
    }
    
    .vgt-responsive{
        overflow-x: none!important;
        overflow: none!important;
    }
    
    .vgt-responsive .dropdown-toggle{
        padding: .1rem 0.35rem;
        font-size: 0.8rem;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/leadOrders.vue